'use client';
/* eslint-disable no-unused-vars */
import * as React from 'react';

/**
 * Listens for clicks outside/inside of an element by checking if such element is
 * a descendant node of the container
 *
 * @param onClickOutside Fired when the user clicks outside
 * @param onClickInside Fired when the user clicks inside
 * @param disableEffect Optionally disable the logic in this hook
 */
export function useClickOutside(
  onClickOutside: (event: MouseEvent) => void,
  onClickInside?: ((event: MouseEvent) => void) | null,
  disableEffect?: boolean,
): React.RefObject<HTMLDivElement | null> {
  const container = React.useRef<HTMLDivElement | null>(null);
  // Listen for clicks outside the input/keyboard area

  React.useEffect(() => {
    if (!disableEffect) {
      const handler = (event: MouseEvent) => {
        if (container.current && event.target instanceof Element) {
          if (!container.current.contains(event.target)) {
            onClickOutside(event);
          } else if (onClickInside) {
            onClickInside(event);
          }
        }
      };

      window.addEventListener('click', handler);
      // clean up when unmounting
      return () => window.removeEventListener('click', handler);
    }
  }, [disableEffect, onClickInside, onClickOutside]);
  return container;
}
